import { useState } from 'react';
import { imageGalleryScrollTracking } from '../../Listings.tracking';

const useSlideTracking = (listingId: string) => {
    const [, setHasFired] = useState<boolean>(false);

    return () => {
        setHasFired((oldState) => {
            if (!oldState) imageGalleryScrollTracking(listingId);

            return true;
        });
    };
};

export default useSlideTracking;
